import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFingerprint } from 'react-fingerprint';
import { enviroments } from '../../utils/constants';
import { RootState } from '../store';

export interface UserInterface {
  user: {
    userTypeId: number | undefined;
    languageId: number | undefined;
    deviceTypeId: number | undefined;
    tokenDevice: any;
    bearerToken: string | undefined;
    id: number | undefined;
    username: string | undefined;
    enabled: boolean | undefined;
    roles: Array<any> | undefined;
    alias: string | undefined,
    email: string | undefined,
  };
}

getFingerprint().then((token: string) => {
  return token;
});

const initialState: UserInterface = {
  user: {
    userTypeId: enviroments.userTypeId.anonymous,
    languageId: enviroments.languageId,
    deviceTypeId: parseInt(enviroments.deviceTypeId ? enviroments.deviceTypeId : ''),
    tokenDevice: '',
    bearerToken: undefined,
    id: undefined,
    username: undefined,
    enabled: undefined,
    roles: undefined,
    alias: undefined,
    email: undefined,
  },
};

export const userSliceFingerprint = createAsyncThunk<any>('', async () => {
  const userFromLocalStorage = JSON.parse(localStorage.getItem('userAccountInformation') || '{}');
  if (userFromLocalStorage.tokenDevice) {
    return userFromLocalStorage.tokenDevice;
  };
  const response = await getFingerprint();
  return response;
});

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    userTypeIdUpdate: (state, action) => {
      state.user.userTypeId = action.payload;
    },
    languageIdUpdate: (state, action) => {
      state.user.languageId = action.payload;
    },
    deviceTypeIdUpdate: (state, action) => {
      state.user.deviceTypeId = action.payload;
    },
    tokenDeviceUpdate: (state, action) => {
      state.user.tokenDevice = action.payload;
    },
    updateUserData: (state, action: any) => {
      state.user = { ...state.user, ...action.payload };
    },
    resetUserData: (state) => {
      state.user = {...initialState.user};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(userSliceFingerprint.fulfilled, (state, action) => {
      state.user.tokenDevice = action.payload;
    });
  },
});

export const { userTypeIdUpdate, languageIdUpdate,  deviceTypeIdUpdate,  tokenDeviceUpdate,  updateUserData,  resetUserData} = userSlice.actions;
export default userSlice.reducer;

export const userState = (state: RootState) => state.user.user;
